var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22241 12.8781V6.76558L4.27241 8.71558L3.22241 7.62808L6.97241 3.87808L10.7224 7.62808L9.67241 8.71558L7.72241 6.76558V12.8781H6.22241ZM0.972412 4.62808V2.37808C0.972412 1.96558 1.11929 1.61246 1.41304 1.31871C1.70679 1.02496 2.05991 0.878082 2.47241 0.878082H11.4724C11.8849 0.878082 12.238 1.02496 12.5318 1.31871C12.8255 1.61246 12.9724 1.96558 12.9724 2.37808V4.62808H11.4724V2.37808H2.47241V4.62808H0.972412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.013b9c6817400d396ebb5035c83e2093.svg";
export { ForwardRef as ReactComponent };